export default "__VITE_ASSET__21b1a92b__"